import extendNode from '../extendNode.mjs'
import Color from '../Color.mjs'
import IconLetters from '../icons/IconLetters.jsx'
import usePseudoNode from '../_PSEUDO/usePseudoNode.jsx'
import meta from './metaPk.mjs'

export default () => {
    const PseudoNode = usePseudoNode()

    return extendNode(PseudoNode, {
        ...meta,

        canDeleteTree() {
            return false
        },

        getIcons(map, node) {
            return [
                <IconLetters
                    key="type"
                    fill={Color.DARK_CYAN}
                    letters="P"
                    textColor="#666"
                />
            ]
        },

        getStyle(map, node) {
            return {
                ...PseudoNode.getStyle.call(this, map, node),
                backgroundColor: '#fff',
                borderColor: Color.CYAN,
            }
        },
    })
}
